import { Reveal } from "@/components/Reveal";
import { STUDIO_IMG } from "@/lib/constants";
import { useLang } from "@/i18n/LanguageContext";

function Marquee({ tags }) {
  const items = [...tags, "Founding Member", ...tags, "AURA+", ...tags];
  return (
    <div data-testid="marquee" className="relative overflow-hidden py-6 border-y border-white/10 bg-[#050505]">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
            {items.map((t, i) => (
              <span key={`${dup}-${i}`} className="flex items-center">
                <span className="font-display text-lg md:text-2xl uppercase tracking-[0.25em] text-zinc-500 px-8">{t}</span>
                <span className="text-white/30">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export function WhatWeLookFor() {
  const { t } = useLang();
  const tags = t("what.tags");
  return (
    <section id="program" data-testid="what-section" className="relative z-10 bg-[#050505]">
      <div className="py-24 md:py-36">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <Reveal>
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">{t("what.overline")}</span>
            <h2 className="font-display font-bold tracking-[-0.02em] text-white text-4xl md:text-5xl lg:text-6xl mt-5 leading-[1.03]">
              {t("what.heading")}
            </h2>
            <p className="mt-7 text-lg text-zinc-400 leading-relaxed max-w-lg">
              {t("what.subPre")}<span className="text-white">{t("what.subEmph")}</span>{t("what.subPost")}
            </p>
            <div className="mt-9 flex flex-wrap gap-3">
              {tags.map((tag) => (
                <span key={tag} data-testid={`interest-${tag}`} className="rounded-full border border-aura-border bg-aura-surface px-5 py-2.5 text-sm text-zinc-300 hover:border-white hover:text-white transition-colors duration-300">
                  {tag}
                </span>
              ))}
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="relative rounded-2xl overflow-hidden border border-aura-border aspect-[4/5]">
              <img src={STUDIO_IMG} alt="Creator studio" className="w-full h-full object-cover opacity-70" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/80 via-transparent to-transparent" />
              <div className="absolute bottom-6 inset-x-6">
                <p className="font-display text-xl md:text-2xl text-white font-medium">{t("what.quote")}</p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
      <Marquee tags={tags} />
    </section>
  );
}
